export default "__VITE_ASSET__DBbJHpyw__"